import type { Messages } from './en';

export const it: Messages = {
  'nav.clientHub': 'Portale Clienti',
  'nav.menu': 'Menu',
  'nav.home': 'Home',
  'nav.products': 'Prodotti',
  'nav.liveCasino': 'Casino live',
  'nav.slots': 'Slot',
  'nav.tableGames': 'Giochi da tavolo',
  'nav.library': 'Libreria',
  'nav.roadmap': 'Roadmap',
  'nav.assets': 'Risorse',
  'nav.guidelines': 'Linee guida',
  'nav.account': 'Account',
  'nav.signOut': 'Esci',
  'nav.categoriesAria': 'Categorie di giochi',
  'nav.sectionsAria': 'Sezioni principali',
  'nav.brandAria': 'RichyPlay Portale Clienti',
  'nav.comingSoon': 'Prossimamente',
  'nav.soon': 'Presto',

  'lang.label': 'Lingua',
  'lang.select': 'Seleziona lingua',

  'category.live': 'Live',
  'category.slot': 'Slot',
  'category.instant': 'Instant',
  'category.table': 'Tavolo',

  'status.planned': 'Pianificato',
  'status.in_progress': 'In corso',
  'status.shipped': 'Rilasciato',
  'status.available': 'Disponibile',
  'status.coming_soon': 'Prossimamente',
  'status.maintenance': 'Manutenzione',

  'common.error': 'Qualcosa è andato storto',
  'common.checkingSession': 'Verifica della sessione…',
  'common.yes': 'Sì',
  'common.no': 'No',
  'common.none': 'Nessuno',
  'common.active': 'Attivo',
  'common.inactive': 'Inattivo',

  'home.eyebrow': 'Portale operatore',
  'home.title': 'Portale Clienti',
  'home.lead':
    'Esplora il portfolio RichyPlay: avvia le demo, segui la roadmap e scarica le risorse di brand da un unico spazio di lavoro.',
  'home.enterLibrary': 'Entra nella libreria',
  'home.viewRoadmap': 'Vedi la roadmap',
  'home.browse': 'Sfoglia per categoria',
  'home.openLibrary': 'Apri la libreria',

  'library.eyebrow': 'Libreria giochi',
  'library.title': 'Portfolio',
  'library.liveTitle': 'Portfolio Live Casino',
  'library.slotTitle': 'Portfolio Slot',
  'library.liveLead': 'Scegli un prodotto live. Blackjack e Roulette sono attivi; gli altri arrivano presto.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'Cerca e filtra il catalogo RichyPlay. Avvia le demo in una nuova scheda.',
  'library.search': 'Cerca giochi…',
  'library.statusFilterAria': 'Filtra per stato',
  'library.statusAll': 'Tutti gli stati',
  'library.loading': 'Caricamento giochi…',
  'library.unavailableTitle': 'Libreria non disponibile',
  'library.unavailableMessage':
    'Impossibile caricare la libreria dei giochi. Il catalogo potrebbe non essere disponibile.',
  'library.apiFailedMessage':
    'Non è stato possibile raggiungere l’API del catalogo. Riprova più tardi o contatta il supporto.',
  'library.emptyTitle': 'Nessun gioco trovato',
  'library.emptyMessage': 'Prova con un’altra ricerca o un altro filtro di categoria.',
  'library.viewGame': 'Vedi il gioco',

  'game.loading': 'Caricamento gioco…',
  'game.notFound': 'Gioco non trovato.',
  'game.back': 'Indietro',
  'game.breadcrumbAria': 'Percorso di navigazione',
  'game.liveCasino': 'Casinò live',
  'game.slots': 'Slot',
  'game.demoFrameTitle': 'Demo di {title}',
  'game.startingDemo': 'Avvio della sessione demo…',
  'game.demoNotStarted': 'Non è stato possibile avviare la sessione demo.',
  'game.demoBadge': 'Modalità demo',
  'game.blockedMaintenance': 'Questo gioco è in manutenzione.',
  'game.blockedComingSoon': 'Prossimamente: la demo non è ancora pubblicata.',
  'game.blockedNoDemo': 'Il catalogo operatore non prevede una versione demo per questo titolo.',
  'game.currency': 'Valuta',
  'game.language': 'Lingua',
  'game.reloadDemo': 'Ricarica la demo',
  'game.startDemo': 'Avvia la demo',
  'game.openNewTab': 'Apri in una nuova scheda',
  'game.copyLink': 'Copia link',
  'game.copied': 'Copiato',
  'game.demoFailedTitle': 'Avvio della demo non riuscito',
  'game.demoUrlMissing': 'Il server non ha restituito l’URL di avvio.',
  'game.demoFailed': 'Impossibile avviare la demo.',
  'game.highlighted': 'In evidenza',
  'game.features': 'Funzionalità del gioco',
  'game.keyFeatures': 'Caratteristiche principali',
  'liveTable.title': 'Tavoli disponibili',
  'liveTable.totalResults': 'Risultati totali:',
  'liveTable.download': 'Scarica dati tavolo',
  'liveTable.gameId': 'ID gioco',
  'liveTable.tableName': 'Nome del tavolo',
  'liveTable.minLimit': 'Limite minimo',
  'liveTable.maxLimit': 'Limite massimo',
  'liveTable.hours': 'Orari operativi UTC',
  'liveTable.language': 'Lingua operativa',
  'liveTable.releaseDate': 'Data di rilascio',
  'liveTable.location': 'Sede',
  'game.betLevels': 'Livelli di puntata',
  'game.tableRules': 'Regole del tavolo',
  'game.mathConfig': 'Configurazione matematica',
  'game.resources': 'Risorse',
  'game.relatedAssets': 'Risorse correlate',
  'game.releaseRoadmap': 'Roadmap dei rilasci',
  'game.integrationGuidelines': 'Linee guida di integrazione',
  'game.information': 'Informazioni sul gioco',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Desktop',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Mobile',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'La scheda dati del gioco sarà aggiunta a breve.',

  'spec.numericId': 'ID numerico',
  'spec.minBetPerLine': 'Puntata minima per linea',
  'spec.minTotalBet': 'Puntata totale minima',
  'spec.maxTotalBet': 'Puntata totale massima',
  'spec.maxTotalBetAnte': 'Puntata totale max con Ante',
  'spec.reels': 'Rulli',
  'spec.rows': 'Righe',
  'spec.payType': 'Tipo di vincita',
  'spec.payLinesValue': '{count} linee',
  'spec.symbolPays': 'Vincite dei simboli',
  'spec.betMultiplier': 'Moltiplicatore di puntata',
  'spec.maxMultiplierWin': 'Vincita max moltiplicatore',
  'spec.maxExposure': 'Esposizione massima',
  'spec.bonusBuyX': 'Acquisto bonus X',
  'spec.anteBetX': 'Puntata Ante X',
  'spec.rtps': 'RTP',
  'spec.hitFrequency': 'Frequenza di vincita',
  'spec.oneIn': '1 su {value}',
  'spec.hasReplay': 'Replay',
  'spec.hasBuySpins': 'Acquisto giri',
  'spec.hasInstantBonus': 'Bonus istantaneo',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Puntata Ante',
  'spec.releaseDate': 'Data di rilascio',
  'spec.symbol': 'Simbolo del gioco',
  'spec.referenceId': 'ID di riferimento',
  'spec.provider': 'Provider',
  'spec.product': 'Prodotto',
  'spec.gameType': 'Tipo di gioco',
  'spec.category': 'Categoria',
  'spec.theme': 'Tema',
  'spec.technology': 'Tecnologia',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Volatilità',
  'spec.maxWin': 'Vincita massima',
  'spec.paylines': 'Linee di pagamento',
  'spec.grid': 'Griglia',
  'spec.bonusFrequency': 'Frequenza bonus',
  'spec.bonusFrequencyValue': '1 su {value}',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Intervallo di puntata',
  'spec.defaultBet': 'Puntata predefinita',
  'spec.currency': 'Valuta',
  'spec.languages': 'Lingue',
  'spec.demoAvailable': 'Demo disponibile',
  'spec.tournaments': 'Tornei',
  'spec.highlighted': 'In evidenza',
  'spec.status': 'Stato',
  'spec.version': 'Versione',
  'spec.lastUpdated': 'Ultimo aggiornamento',

  'roadmap.eyebrow': 'Roadmap di prodotto',
  'roadmap.title': 'Prossimi passi',
  'roadmap.lead': 'Segui i prossimi rilasci e i titoli pubblicati per categoria.',
  'roadmap.bannerAria': 'Prossimi rilasci',
  'roadmap.soonTitle': 'Prossimamente',
  'roadmap.loading': 'Caricamento roadmap…',
  'roadmap.error': 'Impossibile caricare gli elementi della roadmap.',
  'roadmap.emptyTitle': 'Nessun elemento nella roadmap',
  'roadmap.emptyMessage': 'Non ci sono ancora voci pubblicate per questa categoria.',
  'roadmap.itemCount': '{count} elementi',
  'roadmap.target': 'Obiettivo: {date}',
  'roadmap.viewInLibrary': 'Vedi nella libreria',

  'upcoming.title': 'Prossimi rilasci',
  'upcoming.playDemo': 'Gioca demo',
  'upcoming.prev': 'Rilasci precedenti',
  'upcoming.next': 'Rilasci successivi',

  'assets.eyebrow': 'Risorse di brand',
  'assets.title': 'Pacchetti di risorse',
  'assets.lead':
    'Scarica loghi, key art e materiali di marketing. Consulta {link} per le regole di utilizzo.',
  'assets.leadLink': 'le linee guida sulle risorse',
  'assets.loading': 'Caricamento risorse…',
  'assets.error': 'Impossibile caricare i pacchetti di risorse.',
  'assets.downloadFailed': 'Download non riuscito.',
  'assets.emptyTitle': 'Ancora nessuna risorsa',
  'assets.emptyForGame': 'Nessun pacchetto di risorse è collegato a questo gioco.',
  'assets.emptyGeneral': 'I pacchetti di risorse appariranno qui una volta pubblicati.',
  'assets.pack': 'Pacchetto',
  'assets.updated': 'Aggiornato il {date}',
  'assets.download': 'Scarica',
  'assets.search': 'Cerca per nome del gioco…',
  'assets.searchEmpty': 'Nessun gioco corrisponde a questo nome.',

  'guidelines.eyebrow': 'Documentazione',
  'guidelines.title': 'Linee guida',
  'guidelines.lead': 'Note di integrazione, uso delle risorse e riferimenti per gli operatori.',
  'guidelines.all': 'Tutte',
  'guidelines.integration': 'Integrazione',
  'guidelines.assets': 'Risorse',
  'guidelines.loading': 'Caricamento linee guida…',
  'guidelines.error': 'Impossibile caricare le linee guida.',
  'guidelines.emptyTitle': 'Nessuna linea guida',
  'guidelines.emptyMessage': 'Le linee guida pubblicate appariranno qui.',
  'guidelines.index': 'Indice',
  'guidelines.navAria': 'Navigazione linee guida',
  'guidelines.articleLoading': 'Caricamento articolo…',
  'guidelines.notFound': 'Linea guida non trovata.',
  'guidelines.notFoundShort': 'Non trovato',
  'guidelines.updated': 'Aggiornato il {date}',
  'guidelines.external': 'Il contenuto è ospitato esternamente.',
  'guidelines.openDocument': 'Apri il documento',
  'guidelines.typeGuide': 'Guida',
  'guidelines.typeGuideline': 'Linea guida',

  'account.eyebrow': 'Il tuo account',
  'account.title': 'Profilo',
  'account.email': 'E-mail',
  'account.language': 'Lingua dell’interfaccia',
  'account.recentActivity': 'Attività recente',
  'account.loadingActivity': 'Caricamento attività…',
  'account.activityUnavailable': 'L’attività recente non è disponibile al momento.',
  'account.noActivity': 'Nessuna attività recente registrata.',

  'event.login': 'Accesso effettuato',
  'event.logout': 'Disconnessione',
  'event.libraryView': 'Libreria visualizzata',
  'event.gameView': 'Gioco visualizzato',
  'event.demoLaunch': 'Demo avviata',
  'event.demoLaunchFailed': 'Avvio della demo non riuscito',
  'event.assetDownload': 'Risorsa scaricata',
  'event.guidelineView': 'Linea guida visualizzata',
  'event.roadmapView': 'Roadmap visualizzata',

  'auth.title': 'Portale Clienti',
  'auth.subtitle': 'Accedi con le tue credenziali da operatore',
  'auth.email': 'E-mail',
  'auth.password': 'Password',
  'auth.rememberMe': 'Ricordami',
  'auth.signIn': 'Accedi',
  'auth.signInFailed': 'Accesso non riuscito',
  'auth.signInError': 'Impossibile accedere. Controlla le credenziali e riprova.',
  'auth.forgotPassword': 'Password dimenticata?',
  'auth.inviteOnly': 'Accesso solo su invito. Contatta il tuo referente RichyPlay.',
  'auth.visitSiteAria': 'Vai a richyplay.live',

  'footer.navAria': 'Piè di pagina',
  'footer.tagline': 'Portale operatori per il catalogo slot e live casino di RichyPlay.',
  'footer.rights': 'Tutti i diritti riservati.',
  'footer.legal': 'Accesso su invito per operatori autorizzati. Solo per uso professionale.',

  'forgot.eyebrow': 'Reimposta password',
  'forgot.title': 'Password dimenticata',
  'forgot.requestSubtitle':
    'Inserisci la tua e-mail: invieremo un codice di verifica se esiste un account.',
  'forgot.sendCode': 'Invia codice',
  'forgot.sendError': 'Impossibile inviare il codice di reimpostazione.',
  'forgot.confirmSubtitle': 'Inserisci il codice ricevuto via e-mail e scegli una nuova password.',
  'forgot.code': 'Codice di verifica',
  'forgot.newPassword': 'Nuova password',
  'forgot.update': 'Aggiorna password',
  'forgot.updateError': 'Impossibile reimpostare la password.',
  'forgot.doneSubtitle': 'La tua password è stata aggiornata. Ora puoi accedere.',
  'forgot.backToSignIn': 'Torna all’accesso',
};
